/* eslint-disable angular/controller-as */

angular.
module("dx.webapp.exams").
controller("DxExamInfoPopupController", function ExamInfoPopupController(
	$location,
	$scope,
	$window,

	dxExamsNavigator,
	DX_EXAMS_STEPS,
	examStatus,
	DX_URLS,
	DX_INVIGILATOR_SETTINGS,
	dxSession,
	RoleTypeEnum,
	dxApi,

	dxDialog
) {
	"use strict";

	/**
	 * Required $scope values:
	 * - "exam", {Exam}
	 * - "scheduled", {boolan}
	 **/

	var examId = $scope.exam.id;

	$scope.examStatus = examStatus;

	$scope.download = true;

	var invigilatorSettings = DX_INVIGILATOR_SETTINGS.NONE;
	var isInvigilator = dxSession.getRole().roleType === RoleTypeEnum.INVIGILATOR;

	$scope.close = function close() {
		if ($scope.canDownload() && $scope.download) {
			$window.location.href = dxApi.v1.exams.download($scope.exam.id);
		}

		dxDialog.closeMostRecent();

		if (!isInvigilator) {
			// Route to the scheduled or ongoing step on the exams page.
			var examStep = $scope.scheduled ? DX_EXAMS_STEPS.scheduled : DX_EXAMS_STEPS.ongoing;
			$location.url(DX_URLS.get("exams") + dxExamsNavigator(examStep, examId));
		}
	};

	$scope.canDownload = function canDownload() {
		return !isInvigilator || invigilatorSettings & DX_INVIGILATOR_SETTINGS.DOWNLOAD_EXAM;
	};

	function getInvigilatorSettings() {
		dxApi.v1.exams.shares.data.get().then(function saveSettings(response) {
			invigilatorSettings = response.data.find(function findSetting(settings) {
				return settings.objectId === $scope.exam.id;
			}).data[0];
		});
	}

	getInvigilatorSettings();
});
